/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { publicChallengeClipItemSchema } from '../listPublicChallengeClipsBySlugV1/list-public-challenge-clips-by-slug-v1-response';

export const publicChallengeClipItemV2Schema = publicChallengeClipItemSchema.extend({
  collectionTitle: z.string().nullable(),
  parentTitle: z.string().nullable(),
  year: z.number().nullable(),
});

export type IPublicChallengeClipItemV2 = z.infer<typeof publicChallengeClipItemV2Schema>;

export const listPublicChallengeClipsBySlugV2ResponseDataSchema = z.array(
  publicChallengeClipItemV2Schema,
);

export type IListPublicChallengeClipsBySlugV2ResponseData = z.infer<
  typeof listPublicChallengeClipsBySlugV2ResponseDataSchema
>;

export const listPublicChallengeClipsBySlugV2ResponseSchema = createApiResponseSchema(
  listPublicChallengeClipsBySlugV2ResponseDataSchema,
) as z.ZodSchema<IAPI<IListPublicChallengeClipsBySlugV2ResponseData>>;

export type IListPublicChallengeClipsBySlugV2Response =
  IAPI<IListPublicChallengeClipsBySlugV2ResponseData>;
